import { Grid } from '@mui/material';
import React, { useMemo } from 'react';
import { useNavigate } from 'react-router';
import { cardStyle } from 'views/OrderNewProductOrService/OrderNewProductOrService';
import CardBodyComponent from '../common/card/CardBodyComponent';
import CardTooltipButton from '../common/card/CardTooltipButton';
import { Features } from 'reducers/partnerStatusReducer';
import { FeatureEligibility } from 'pco-product-service-internal-consumer';
import { useSelector } from 'react-redux';
import { selectIsEligible } from 'selectors/partnerStatusSelector';

interface AddProductProps {
  partnerId?: string;
  brUid?: string;
}

const AddProduct = ({ partnerId, brUid }: AddProductProps) => {
  const navigate = useNavigate();
  const isEligibleForAddProductStore = useSelector(selectIsEligible) as
    | (FeatureEligibility[] & { messages?: string[] })
    | undefined;

  const isEligibleForAddProduct = useMemo<FeatureEligibility | undefined>(() => {
    if (isEligibleForAddProductStore?.messages) return undefined;
    return (
      isEligibleForAddProductStore?.find((eligibility) => eligibility.feature === Features.ADD_PRODUCTS) ?? undefined
    );
  }, [isEligibleForAddProductStore]);

  const title = useMemo<React.ReactNode>(() => {
    if (isEligibleForAddProductStore?.messages) {
      const messages = isEligibleForAddProductStore.messages;
      return (
        <>
          <div>{partnerId ? 'Partner' : 'Business relation '} is missing following data:</div>
          {messages.map((message, index) => (
            <div key={index}>{message}</div>
          ))}
        </>
      );
    }
    return `${partnerId ? 'Partner' : 'Business relation'} is not eligible for Adding Products`;
  }, [isEligibleForAddProductStore, partnerId]);

  const handleAddNewProductOrServiceClick = () => {
    if (partnerId) {
      navigate(`/partner/${partnerId}/addProductOrService`);
    }
    if (brUid) {
      navigate(`/accounts/${brUid}/addProductOrService`);
    }
  };

  return (
    <Grid data-testid="add-product" item sx={cardStyle}>
      <CardBodyComponent
        content={`Add new product or service for this ${partnerId ? 'partner' : 'business relation'}.`}
      />
      <CardTooltipButton
        id={'add-new-product-button'}
        data-testid={'add-new-product-button'}
        buttonText={'Add new'}
        isEligible={isEligibleForAddProduct?.isEligible ?? false}
        handleClick={handleAddNewProductOrServiceClick}
        tooltipTitle={title}
      />
    </Grid>
  );
};

export default AddProduct;
